import { render, staticRenderFns } from "./AppQuestion9.vue?vue&type=template&id=0835b4b9&"
import script from "./AppQuestion9.vue?vue&type=script&lang=js&"
export * from "./AppQuestion9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports